import { Component, OnInit } from "@angular/core";
import { Params } from "@angular/router";
import { AuthUserDbService } from "@app/auth/services/auth-user-db.service";
import { AuthUserService } from "@app/auth/services/auth-user.service";
import { RouterService } from "@app/root-store/router.service";
import { Observable, tap } from "rxjs";
@Component({
    selector: "app-login-page",
    templateUrl: "./login-page.component.html",
    styleUrls: ["./login-page.component.scss"],
})
export class LoginPageComponent implements OnInit {
    public queryParams$: Observable<Params> = this.routerService.getQueryParams().pipe(tap(this.checkParams()));

    constructor(
        private readonly authUserDbService: AuthUserDbService,
        private readonly routerService: RouterService,
        private readonly authUserService: AuthUserService
    ) {}

    ngOnInit() {
        this.authUserDbService.isPendingLoginState = false;
        this.authUserService.dispatchClearErrorPendingTrue(); // reset pending to true since staff can navigate here from register form
    }

    private checkParams(): (params: Params) => void {
        return (params: Params) => {
            // if redirect params indicate it's a customer, add staff=false to URL
            if (params?.redirectTo?.includes("staff=false") && !params?.staff) {
                this.routerService.navigateToUrl(["/login"], { queryParamsHandling: "merge" }, { staff: false });
            }
        };
    }
}
